import { useRef, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { httpActions } from '@figure/frontlib-onboarding-redux';

const useLoader = (message, enabled) => {
  const createAction = (message) => httpActions.overrideCreator(() => ({ message }));
  const requestRef = useRef(createAction());
  const enabledRef = useRef(false);
  const dispatch = useDispatch();

  useEffect(() => {
    requestRef.current = createAction(message);
  }, [message]);

  useEffect(() => {
    if (enabled !== enabledRef.current) {
      enabledRef.current = enabled;

      dispatch(enabled ? requestRef.current() : httpActions.complete());
    }

    return () => {
      if (enabled) dispatch(httpActions.complete());
    };
  }, [dispatch, enabled]);
};

export default useLoader;
